import React, {Component} from "react";
import compose from "lodash/flowRight";
import {graphql} from "react-apollo";
import get from "lodash/get";
import recordActivityMutation from "../mutations/recordActivityMutation";

function withActivity(app, activity, activitySource) {
    return function wrappedWithActivity(WrappedComponent) {
        class withActivityContainer extends Component {
            componentDidMount() {
                if (!activitySource) {
                    if (get(this.props, "match.params.universitySlug")) {
                        activitySource = {
                            slug: this.props.match.params.universitySlug,
                            type: "university",
                        };
                    } else if (get(this.props, "me.mentor.university")) {
                        activitySource = {
                            slug: this.props.me.mentor.university.slug,
                            type: "university",
                        };
                    } else if (get(this.props, "authState.me.mentor.university")) {
                        activitySource = {
                            slug: this.props.authState.me.mentor.university.slug,
                            type: "university",
                        };
                    }
                }
                this.props.recordActivity({
                    variables: {
                        app,
                        activity,
                        activitySource: activitySource ? JSON.stringify(activitySource) : undefined,
                    },
                });
            }

            render() {
                return <WrappedComponent {...this.props} />;
            }
        }

        return compose(graphql(recordActivityMutation, {name: "recordActivity"}))(
            withActivityContainer,
        );
    };
}

export default withActivity;
